import { render, staticRenderFns } from "./baseTradeTerm.vue?vue&type=template&id=c7be96ac&"
import script from "./baseTradeTerm.vue?vue&type=script&lang=js&"
export * from "./baseTradeTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7be96ac')) {
      api.createRecord('c7be96ac', component.options)
    } else {
      api.reload('c7be96ac', component.options)
    }
    module.hot.accept("./baseTradeTerm.vue?vue&type=template&id=c7be96ac&", function () {
      api.rerender('c7be96ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/baseTradeTerm.vue"
export default component.exports